import { createReducer, on } from '@ngrx/store';
import { VehicleCheckActions } from './vehicle-check.actions';
import { VehicleCheckItem } from '@core/interface/fleet/daily-vehicle-check';
import { Pagination } from '@core/interface/core';

export const vehicleCheckFeatureKey = 'vehicleCheck';

export interface VehicleCheckState {
  inspection: {
    data: VehicleCheckItem[];
    isLoading: boolean;
    pagination: Pagination | null;
  };
  isVerified: boolean;
  correctiveActionUpdated: boolean;
  isPDFLoading: boolean;
}

export const initialState: VehicleCheckState = {
  inspection: {
    data: [],
    isLoading: false,
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 10,
      total: 100,
    },
  },
  isVerified: false,
  correctiveActionUpdated: false,
  isPDFLoading: false,
};

export const VehicleCheckReducer = createReducer(
  initialState,
  on(VehicleCheckActions.loadInspectedVehicles, (state) => ({
    ...state,
    inspection: { ...state.inspection, isLoading: true, data: [] },
  })),
  on(
    VehicleCheckActions.loadInspectedVehiclesSuccess,
    (state, { data, pagination }) => ({
      ...state,
      inspection: { ...state.inspection, data, pagination, isLoading: false },
    })
  ),
  on(VehicleCheckActions.loadInspectedVehiclesFailure, (state) => ({
    ...state,
    inspection: { ...state.inspection, data: [], isLoading: false },
  })),
  on(VehicleCheckActions.resetInspectedVehicles, (state) => ({
    ...state,
    inspection: {
      ...state.inspection,
      data: [],
      isLoading: false,
      pagination: null,
    },
  })),
  on(VehicleCheckActions.markAsVerifiedSuccess, (state) => ({
    ...state,
    isVerified: true,
  })),
  on(VehicleCheckActions.markAsVerifiedFailure, (state) => ({
    ...state,
    isVerified: false,
  })),
  on(VehicleCheckActions.resetVerifiedStatus, (state) => ({
    ...state,
    isVerified: false,
  })),

  on(VehicleCheckActions.updateCorrectiveActionSuccess, (state) => ({
    ...state,
    correctiveActionUpdated: true,
  })),
  on(VehicleCheckActions.updateCorrectiveActionFailure, (state) => ({
    ...state,
    correctiveActionUpdated: false,
  })),
  on(VehicleCheckActions.resetCorrectiveActionStatus, (state) => ({
    ...state,
    correctiveActionUpdated: false,
  })),
  on(VehicleCheckActions.exportPDF, (state) => ({
    ...state,
    isPDFLoading: true,
  })),
  on(VehicleCheckActions.exportPDFSuccess, (state) => ({
    ...state,
    isPDFLoading: false,
  })),
  on(VehicleCheckActions.exportPDFFailure, (state) => ({
    ...state,
    isPDFLoading: false,
  }))
);
